import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const LineDashedChart = ({ watchersTimeData = {} }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        height: 400,
        type: "line",
        toolbar: {
          show: false, // Oculta la barra de herramientas, incluido el menú de descarga
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      fill: {
        type: "solid",
        opacity: [0.35, 0.35, 0.90],
      },
      colors: ["#BAE6FD", "#FECDD3", "#FEB019", "#1EBD41"],
      legend: {
        show: true,
        //   position: "right", // Posiciona la leyenda en el lado derecho
        //   verticalAlign: "middle", // Centra la leyenda verticalmente
        //   tooltipHoverFormatter: function (val, opts) {
        //     return (
        //       val +
        //       " - <strong>" +
        //       opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
        //       "</strong>"
        //     );
        //   },
        // },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        categories: [],
        type: "category",
        tickAmount: 5, // Limita la cantidad de etiquetas del eje X a 10
        labels: {
          trim: false, 
          rotate: -60, 
        },
      },
      yaxis: [
        {
          title: {
            text: "Observadores",
          },
          labels: {
            formatter: function (val) {
              return val.toFixed(0); 
            },
          },
        },
        {
          opposite: true,
          title: {
            text: "Tiempo (s.)",
            style: {
              // color: "#FEB019", 
            },
          },
          labels: {
            style: {
              // colors: "#FEB019", 
            },
            formatter: function (val) {
              return val.toFixed(0); 
            },
          },
        },
      ],
      grid: {
        borderColor: "#f1f1f1",
      },
    },
  });

  useEffect(() => {
    if (watchersTimeData.seriesData && watchersTimeData.categories) {
      const filteredSeriesData = watchersTimeData.seriesData.filter(
        (series) => {
          return series.data.some((value) => value !== 0);
        }
      );

      filteredSeriesData.sort((a, b) => {
        if (a.type === 'line') return 1;
        if (b.type === 'line') return -1;
        return 0;
      });


      setChartData((prev) => ({
        ...prev,
        series: filteredSeriesData,
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis,
            categories: watchersTimeData.categories,
          },
        },
      }));
    }
  }, [watchersTimeData]);

  return (
    <div className="bg-white shadow-xl rounded-xl">
      <h2 className="p-2 mx-4 -my-4 text-xl font-bold text-left ">
        Observadores vs Tiempo
      </h2>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="line"
          height={250}
        />
      </div>
    </div>
  );
};

export default LineDashedChart;
